import React from 'react';

const VideoEmbed = () => {
  return (
    <div className="video-container" style={{ 
      width: '100%', 
      maxWidth: '936px',
      margin: '60px auto',
      backgroundColor: 'black',
      borderRadius: '8px',
      overflow: 'hidden'
    }}>
      <div style={{
        padding: '58px 0',
        width: '100%'
      }}>
        <div style={{
          position: 'relative',
          paddingBottom: '56.25%',
          height: 0,
          overflow: 'hidden'
        }}>
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            src="https://fast.wistia.net/embed/iframe/g1c9olo0da"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoEmbed;